export const DATEPICKER_SET_YEAR = 'DATEPICKER_SET_YEAR';
export const DATEPICKER_SET_MONTH = 'DATEPICKER_SET_MONTH';
